import { storeToRefs } from "pinia"
import { useUserAccountsStore } from "../../stores/userAccounts"

class IncrementActiveQrsTotal {
  static apply() {
    const { userAccount } = storeToRefs(useUserAccountsStore())
    userAccount.value.totals.qr = userAccount.value.totals.qr + 1
  }
}

export default IncrementActiveQrsTotal
